import React from "react";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Style from "./datepicker.module.scss";
import "./nextPrevArrow.scss";
import PropTypes from "prop-types";
import { dMMMyyyy } from "../../utils/constants/appConstants";
import { handleDateChange, handleRawDateChange } from "../../utils/dateUtils";

const DatePickerWithText = ({
  placeholder,
  minDate,
  maxDate,
  value,
  onChange
}) => {
  return (
    <Datepicker
      className={`${Style.datepicercustom} ${Style.datePickercustomHeight}`}
      selected={value}
      onChange={(date) => handleDateChange(date, onChange)}
      onChangeRaw={(event) =>
        handleRawDateChange({
          event,
          onChange,
          minDate,
          maxDate,
          validateRange: true
        })
      }
      minDate={minDate}
      maxDate={maxDate}
      dateFormat={dMMMyyyy}
      // Without this, react-datepicker parses each keystroke against the
      // format truncated to the text typed so far, so "28-Jul-20" reads as
      // 2020-07-28 and the half-typed date is committed to the caller. Every
      // one of those commits re-renders the caller mid-word, and a controlled
      // input that re-renders between a keypress and React handling it drops
      // the character. handleRawDateChange below already commits the date once
      // the text is a whole one, so strict parsing loses nothing.
      strictParsing
      placeholderText={placeholder}
    />
  );
};

DatePickerWithText.propTypes = {
  placeholder: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onChange: PropTypes.func.isRequired
};

export default DatePickerWithText;
